import React from 'react';
import SearchForm from '../components/SearchForm';

export default function HeroSection() {
  return (
    <div className="relative bg-navy-950 text-white overflow-hidden">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute inset-0 opacity-[0.035]" style={{ backgroundImage: 'linear-gradient(#ffffff 1px, transparent 1px), linear-gradient(90deg, #ffffff 1px, transparent 1px)', backgroundSize: '48px 48px' }} />
        <div className="absolute top-[-15%] right-[-10%] w-[420px] h-[420px] bg-navy-600 opacity-25 rounded-full blur-[140px]" />
        <div className="absolute bottom-[-15%] left-[-5%] w-72 h-72 bg-amber-500 opacity-[0.08] rounded-full blur-[120px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16 lg:pt-20 pb-0">
        <div className="text-center mb-6 sm:mb-8">
          <span className="inline-block text-xs font-bold text-amber-400 uppercase tracking-[0.2em] mb-4">Independent Travel Agency</span>
          <h1 className="font-display text-3xl sm:text-5xl md:text-6xl font-extrabold leading-tight tracking-tight mb-5">
            Flight Booking Assistance &amp;<br className="hidden sm:block" />
            <span className="text-amber-400">
              Travel Support Across the USA
            </span>
          </h1>
          <p className="text-slate-300 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-3">
            TheAirlineFares is an independent travel agency providing flight booking assistance and customer support services.
          </p>
          <p className="text-slate-500 text-sm max-w-xl mx-auto leading-relaxed">
            We are not affiliated with, endorsed by, or associated with any airline.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 sm:gap-3 mb-8">
          {['Transparent Pricing', '24/7 Live Support', 'Domestic & International', 'Secure Booking'].map(pill => (
            <span key={pill} className="bg-white/5 border border-white/10 text-slate-300 text-xs sm:text-sm px-3 sm:px-4 py-1.5 rounded-full">{pill}</span>
          ))}
        </div>

        <div className="bg-white/[0.04] backdrop-blur-2xl border border-white/10 rounded-2xl p-4 sm:p-6 md:p-8 shadow-2xl max-w-5xl mx-auto">
          <SearchForm />
        </div>

        <div className="mt-8 sm:mt-10 pb-12 sm:pb-16 grid grid-cols-2 sm:grid-cols-4 gap-6 sm:gap-8 max-w-2xl sm:max-w-none mx-auto">
          {[
            { value: '500+', label: 'Airlines Covered' },
            { value: '1,000+', label: 'Routes Available' },
            { value: '24/7', label: 'Live Support' },
            { value: '100%', label: 'Transparent Pricing' },
          ].map(s => (
            <div key={s.label} className="text-center">
              <p className="font-display text-2xl sm:text-3xl font-extrabold text-amber-400">{s.value}</p>
              <p className="text-slate-400 text-xs sm:text-sm mt-1">{s.label}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="relative h-12 sm:h-16 -mt-1">
        <svg viewBox="0 0 1440 64" preserveAspectRatio="none" className="absolute bottom-0 w-full h-full" fill="white">
          <path d="M0,32 C240,64 480,0 720,32 C960,64 1200,0 1440,32 L1440,64 L0,64 Z" />
        </svg>
      </div>
    </div>
  );
}
